import { Box, Stack, Typography } from '@mui/material';
import type { Agent } from '@/shared/api/types';
import { AgentIcon } from '@/shared/components/AgentIcon';
import { BrandLogo } from '@/shared/components/BrandLogo';
import { AGENT_HINT, AGENT_LABEL } from '@/shared/lib/format';

const AGENTS: Agent[] = ['intake', 'match', 'call', 'integrity', 'evaluate'];

/** The half of the sign-in page that says what the product does, in the order the agents do it. */
export function LoginAside() {
  return (
    <Box component="aside" sx={{
      display: { xs: 'none', md: 'flex' }, flexDirection: 'column', justifyContent: 'space-between', p: { md: 6, lg: 8 }, borderRight: 1, borderColor: 'divider',
    }}>
      <BrandLogo height={28} />
      <Box sx={{ maxWidth: 520 }}>
        <Typography variant="h1" component="p" sx={{ fontSize: { md: '2.5rem', lg: '2.875rem' }, mb: 2 }}>
          Five agents read, match and call. <Box component="span" sx={{ color: 'text.secondary' }}>You make the call that counts.</Box>
        </Typography>
        <Stack component="ol" sx={{ listStyle: 'none', p: 0, m: 0, mt: 5, gap: 2 }}>
          {AGENTS.map((a, i) => (
            <Stack component="li" key={a} direction="row" sx={{ gap: 2, alignItems: 'flex-start' }}>
              <Typography variant="overline" sx={{ color: 'text.disabled', pt: 0.25, minWidth: 20 }}>{String(i + 1).padStart(2, '0')}</Typography>
              <AgentIcon agent={a} sx={{ fontSize: 18, color: 'text.secondary', mt: 0.25 }} />
              <Box>
                <Typography variant="body2" sx={{ fontWeight: 600 }}>{AGENT_LABEL[a]}</Typography>
                <Typography variant="body2" color="text.secondary">{AGENT_HINT[a]}</Typography>
              </Box>
            </Stack>
          ))}
        </Stack>
      </Box>
      <Typography variant="caption" sx={{ color: 'text.disabled' }}>Screenline by AI Planet, Hyderabad</Typography>
    </Box>
  );
}
